import { useEffect, useLayoutEffect, useRef, useState } from "react";

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Refresh } from "@mui/icons-material";
import BarChart from "../components/BarChart";
import { APP_INFO, USER_NAME_SURNAME } from "../../constants/storageKeys";
import { useSelector, useDispatch } from "react-redux";
import moment from 'moment';
import { getLastOrders } from "../../store/slices/lastOrderListSlice";
import { getOrderSummaryTotal } from "../../store/slices/orderSummaryTotalSlice";
import { getOrderSummaries } from "../../store/slices/orderSummariesSlice";
import { getOrderChartSummaryList } from "../../store/slices/orderChartSummaryListSlice";
import { getAllPackage } from "../../store/slices/packageSlice";
import { formatCurrency, formatDateOnFront, formatDateOnFrontWithoutTime } from "../../lib/helpers";
import { BsPlayFill } from "react-icons/bs";
import { NavLink, useNavigate } from "react-router-dom";
import { getEmailSmsPackage } from "../../store/slices/emailSmsPackageSlice";
import appHelpers from "../../common/helpers/appHelpers";
import { getNavigationUrl } from "../../common/helpers/navigationHelpers";
import { CustomDropdown } from "../components";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProgressLoader, Selector } from "../components/Elements";
import { ThunkDispatch } from "redux-thunk";
import { RootStateType } from "../../store/RootState";
import { tenantState } from "../../store/recoil/tenant/atoms";
import { useRecoilValue } from "recoil";
import { Helmet } from "react-helmet";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { OptionModel } from "../../common/types/OptionModel";
import { getUserIdentity, isUserAuthorizeToMenu } from "../../common/helpers/authorizationHelper";
import Loading from "../components/Loading";


function Dashboard({ }) {
  const appInfo = JSON.parse(localStorage.getItem(APP_INFO) || "{}");
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const orderList = useSelector((state: RootStateType) => state.lastOrderList);
  const orderSummaryTotal = useSelector((state: RootStateType) => state.orderSummaryTotal);
  const orderSummaries = useSelector((state: RootStateType) => state.orderSummaries);
  const orderChartSummaryList = useSelector((state: RootStateType) => state.orderChartSummaryList);
  const allPackage = useSelector((state: RootStateType) => state.package);
  const { emailSmsPackage } = useSelector((state: RootStateType) => state.emailSmsPackage);

  const { firmInformations } = useRecoilValue(tenantState);
  const currencyList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyList);
  const currencySelectList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyListForSelect);
  const platform = appHelpers.getPlatform();
  const isWebPlatform = platform == "web";

  const mainDivRef = useRef<any>();

  const isFetchData = (orderList.isFetching || orderSummaryTotal.isFetching ||
    orderSummaries.isFetching || orderChartSummaryList.isFetching ||
    allPackage.isFetching);

  const [chartValue, setChartValue] = useState(1);
  const [remainderDay, setRemainderDay] = useState(0);
  const [value, setValue] = useState('1');
  const [selectedCurrency, setSelectedCurrency] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState("₺");
  const [prevCurrencySymbol, setPrevCurrencySymbol] = useState("₺");
  const [showTotalCollection, setShowTotalCollection] = useState<boolean>(true);
  const [loadingReports, setLoadingReports] = useState(true);

  const isInitialIdmRef = useRef(true);
  const navigate = useNavigate();
  const isDemoUser = appHelpers.isDemoUser();

  useEffect(() => {
    if (isInitialIdmRef.current == false) {
      checkIdmToken()
    }
    isInitialIdmRef.current = false;
  }, []);

  useLayoutEffect(() => {
    calculateRemainderDay();
  }, []);

  useEffect(() => {
    selectInitialValue();
  }, []);

  useEffect(() => {
    handleTotalCollection();
  }, [])


  useEffect(() => {
    selectMoneyData();
  }, [selectedCurrency]);

  const userIdentity = getUserIdentity();

  const checkIdmToken = () => {
    const idmExpiredDate = sessionStorage.getItem("idm_token_expiredDate");

    var isExpired = formatDateOnFront(idmExpiredDate) >= formatDateOnFront(new Date());
    if (!isExpired) {
      sessionStorage.clear();
      sessionStorage.setItem("idm_old_token", "true");
      navigate("idmLogin")
    }
  }

  const selectInitialValue = () => {
    var params = {
      licenseKey: appHelpers.getLicenceKey() || firmInformations.licenseKey,
      taxCode: appHelpers.getTaxNumber() || firmInformations.taxCode
    }
    dispatch(getAllPackage(params));
    dispatch(getEmailSmsPackage(params));
  }

  const selectMoneyData = () => {
    const userId=["BAYİ/MÜŞTERİ", "ALTBAYİ", "MÜŞTERİ TEMSİLCİSİ"].includes(getUserIdentity())
    ? parseInt(localStorage.getItem("_us_d") || "0", 10)
    : null;
    const params = {
      currencyId: selectedCurrency,
      userid: userId 
    }
    dispatch(getOrderChartSummaryList(params));
    dispatch(getLastOrders(params));
    dispatch(getOrderSummaryTotal(params));
    dispatch(getOrderSummaries(params));
  }

  const onCurrencyChange = (item: OptionModel) => {
    const selected = item.value;
    const symbol = getCurrencySymbol(selected);
    setPrevCurrencySymbol(currencySymbol);
    setCurrencySymbol(symbol);
    setSelectedCurrency(selected);
  }

  const getSelectedCurrency = () => {
    const index = currencySelectList.findIndex(w => w.value == selectedCurrency);
    return currencySelectList[index];
  }

  const getCurrencySymbol = (selected: number) => {
    const index = currencyList.findIndex(w => w.currencyId == selected);
    return currencyList[index].currencySymbol;
  }

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const calculateRemainderDay = () => {
    if (allPackage?.package?.data?.length > 0) {
      const nowDate = new Date(allPackage.package.data[0]?.endDate);
      var present_date = new Date(Date.now());
      var one_day = 1000 * 60 * 60 * 24;
      var reminder = ((nowDate.getTime() - present_date.getTime()) / one_day);
      setRemainderDay(reminder);
    }
  }

  const getRowValue = (maxLength: number, value: any) => {
    var val = (value || "") + "";
    if (maxLength > 0) {
      if (val && val.length > maxLength) {
        var newVal = val.substring(0, maxLength);
        return newVal + "...";
      } else return val;
    } else {
      return value;
    }
  }

  const getRowTooltip = (maxLength: number, value: any) => {
    var val = (value || "") + "";
    if (val && val.length > maxLength) {
      return value;
    } else {
      return null;
    }
  }

  function LinearColor() {
    if (isFetchData) {
      return (
        <ProgressLoader />
      );
    }
  }

  const chartDropdownList = [
    {
      label: "İşlem Tutarı",
      onClickItem: () => setChartValue(1)
    },
    {
      label: "İşlem Adedi",
      onClickItem: () => setChartValue(2)
    }
  ];

  const getNameSurname = () => {
    if (isWebPlatform) {
      return localStorage.getItem(USER_NAME_SURNAME);
    } else {
      const nameSurname = appHelpers.getNameSurname();
      return nameSurname;
    }
  }
  const handleTotalCollection = () => {
    try {
      switch (getUserIdentity()) {
        case "ADMIN":
        case "FİRMA YETKİLİSİ":
        case "MÜŞTERİ TEMSİLCİSİ":
          setShowTotalCollection(true);
          break;
        default:
          setShowTotalCollection(false);
          break;
      }
    } catch (error) {

    } finally {
      setTimeout(() => {
        setLoadingReports(false);
      }, 300);
    }
  }

  return (
    <>
      <PageTitle showFirmInformation={true} title={pageTitleTexts.dashboard} />
      <div className={`border-b border-gray-200 p-2 flex flex-row flex-wrap items-center justify-between  
  w-[${mainDivRef.current?.offsetWidth}px] dashboard-fixed z-10`} style={{
        }}>
        <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ">
          Hoş Geldin {getNameSurname()}
        </span>
        <div className="flex flex-row items-center justify-center ">
          <span className="text-xs text-primary-dark px-2 rounded-full ">
            VKN/TCKN: {appHelpers.getTaxNumber() || firmInformations.taxCode}
          </span>

          {currencyList?.length > 1 && firmInformations.isCurrency === true ? (
            <div className="ml-1 mr-1">
              <Selector
                options={currencySelectList}
                name="sendType"
                placeholder={"Para Birimi"}
                onChange={onCurrencyChange}
                defaultValue={getSelectedCurrency()}
              />
            </div>
          ) : ""}
          <div onClick={selectInitialValue} className="flex items-center text-sm cursor-pointer">
            <Refresh fontSize="small" className="mr-1" />
            <span>Yenile</span>
          </div>
        </div>
      </div>
      {LinearColor()}

      <main className="w-full pt-0 " ref={mainDivRef} style={{
        // marginTop: 75
      }}>

        {(userIdentity == "ADMIN" || userIdentity == "FİRMA YETKİLİSİ") && (
          <div className="px-4 mt-6 sm:px-4 lg:px-4">
            <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-2 xl:grid-cols-4 mt-3">
              <div className="flex flex-col xs:col-span-2 lg:col-span-1 bg-white rounded-md w-full h-24 ">
                <div className="flex flex-row  justify-between items-start xs:ml-4 lg:ml-4 xs:mt-4 lg:mt-4">
                  <p className="xs:mb-3  lg:mb-3  not-italic  text-base leading-5 font-semibold font-nunito text-black-50 " >Paket Bilgileri</p>
                  <div className="grid grid-cols-1 gap-0">

                    <div className="mr-4 flex  flex-column justify-start  justify-center items-center">
                      <a className="not-italic  text-base leading-5 font-semibold font-nunito text-primary"
                        href="https://siparis.elogo.com.tr/"
                        target={"_blank"} >
                        Paket Satın Al
                      </a>
                      <a
                        href="https://siparis.elogo.com.tr/"
                        target={"_blank"}
                      >
                        <BsPlayFill
                          className="text-primary ml-2" />
                      </a>
                    </div>


                  </div>
                </div>
                <div className="-start  ml-4">

                  <div className="flex gap-1 flex flex-row  justify-between items-center ">
                    <div className="justify-center items-center  content-center mt-2">
                      <p className="mb-4  not-italic  font-semibold text-base leading-5 text-black-50">Bitiş Tarihi</p>
                    </div>
                    <b className="mb-2 not-italic font-bold text-xl leading-6 font-nunito text-black-50 pr-5">{isDemoUser ? "Demo" : allPackage?.package?.data?.length > 0 && formatDateOnFrontWithoutTime(allPackage.package.data[0].endDate)}</b>
                  </div>
                </div>
              </div>

              <div className="flex flex-col xs:col-span-2 lg:col-span-1  items-center justify-center bg-white rounded-md w-full h-24">
                <div className="flex flex-col items-start p-0 flex-none order-none self-stretch flex-grow-0  ml-4">
                  <p className="mb-4 not-italic text-black-50    text-base leading-5 font-semibold font-nunito" >Kalan E-Mail İşlem Sayısı</p>
                </div>
                <div className="flex flex-col p-0  flex-none  order-none self-stretch flex-grow-0  ml-4">
                  <p className="not-italic font-semibold text-sm leading-4 text-black-50">
                    <b className="mb-2 not-italic font-bold text-xl leading-6 font-nunito text-black-50" >{isDemoUser ? "5000" : emailSmsPackage?.totalEmail} </b>
                    Adet</p>
                </div>
              </div>

              <div className="flex flex-col xs:col-span-2 lg:col-span-1  items-center justify-center bg-white rounded-md w-full h-24">
                <div className="flex flex-col items-start p-0 flex-none order-none self-stretch flex-grow-0  ml-4">
                  <p className="mb-4 not-italic text-black-50  text-base leading-5 font-semibold font-nunito" >Kalan SMS İşlem Sayısı</p>
                </div>
                <div className="flex flex-col p-0  flex-none  order-none self-stretch flex-grow-0  ml-4">
                  <p className="not-italic font-semibold text-sm leading-4 text-black-50">
                    <b className="mb-2 not-italic font-bold text-xl leading-6 font-nunito text-black-50" >{isDemoUser ? "1000" : emailSmsPackage?.totalSMS} </b>
                    Adet</p>
                </div>
              </div>

              <div className="flex flex-col xs:col-span-2 lg:col-span-1  items-center justify-center bg-white rounded-md w-full h-24">
                <div className="flex flex-col items-start p-0 flex-none order-none self-stretch flex-grow-0  ml-4">
                  <p className="mb-4 not-italic text-black-50  text-base leading-5 font-semibold font-nunito" >Kalan Whatsapp İşlem Sayısı</p>
                </div>
                <div className="flex flex-col p-0  flex-none  order-none self-stretch flex-grow-0  ml-4">
                  <p className="not-italic font-semibold text-sm leading-4 text-black-50">
                    <b className="mb-2 not-italic font-bold text-xl leading-6 font-nunito text-black-50" >{isDemoUser ? "1000" : emailSmsPackage?.totalWhatsapp} </b>
                    Adet</p>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="px-4 mt-6 sm:px-4 lg:px-4">
          <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-2 xl:grid-cols-4 mt-3">
            <div className="flex flex-col items-center   justify-center  bg-white rounded-md w-full h-24">
              <div className="flex flex-col items-start p-0 flex-none order-none self-stretch flex-grow-0  ml-4">
                <p className="mb-4 not-italic  text-black-50 text-base leading-5 font-semibold font-nunito ml-2">Bugün Yapılan Ödemeler</p>
              </div>
              <div className="flex flex-col p-0  flex-none  order-none self-stretch flex-grow-0  ml-6">
                <p className="mb-2 not-italic  text-xl leading-6 font-nunito text-gray-900 font-semibold" >
                  {formatCurrency(orderSummaryTotal?.orderSummaryTotal?.todayCheckout)} {orderSummaryTotal.isFetching ? prevCurrencySymbol : currencySymbol}
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center   justify-center  bg-white rounded-md w-full h-24">
              <div className="flex flex-col items-start p-0 flex-none order-none self-stretch flex-grow-0  ml-4">
                <p className="mb-4  not-italic  text-black-50  text-base leading-5 font-semibold font-nunito " >Bu Hafta Yapılan Ödemeler</p>
              </div>
              <div className="flex flex-col p-0  flex-none  order-none self-stretch flex-grow-0  ml-4">
                <p className="mb-2 not-italic font-bold text-xl leading-6 font-nunito text-black-50">
                  {formatCurrency(orderSummaryTotal?.orderSummaryTotal?.weekCheckout)} {orderSummaryTotal.isFetching ? prevCurrencySymbol : currencySymbol}
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center   justify-center  bg-white rounded-md w-full h-24">
              <div className="flex flex-col items-start p-0 flex-none order-none self-stretch flex-grow-0  ml-4">
                <p className="mb-4  not-italic text-black-50  text-base leading-5 font-semibold font-nunito " >Bu Ay Yapılan Ödemeler</p>
              </div>
              <div className="flex flex-col p-0  flex-none  order-none self-stretch flex-grow-0  ml-4">
                <p className="mb-2 not-italic font-bold text-xl leading-6 font-nunito text-black-50">
                  {formatCurrency(orderSummaryTotal?.orderSummaryTotal?.monthCheckout)} {orderSummaryTotal.isFetching ? prevCurrencySymbol : currencySymbol}
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center   justify-center  bg-white rounded-md w-full h-24">
              <div className="flex flex-col items-start p-0 flex-none order-none self-stretch flex-grow-0  ml-4">
                <p className="mb-4 not-italic  text-black-50 text-base leading-5  font-semibold font-nunito" >Bu Yıl Yapılan Ödemeler</p>
              </div>
              <div className="flex flex-col p-0  flex-none  order-none self-stretch flex-grow-0  ml-4">
                <p className="mb-2 not-italic font-bold text-xl leading-6 font-nunito text-black-50">
                  {formatCurrency(orderSummaryTotal?.orderSummaryTotal?.yearCheckout)} {orderSummaryTotal.isFetching ? prevCurrencySymbol : currencySymbol}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Second Row */}
        <div className={showTotalCollection ? "grid grid-cols-1 gap-4 sm:gap-6 xl:grid-cols-3 mt-6 sm:px-4 lg:px-4 px-4" : "grid grid-cols-1 gap-4 sm:gap-6 xl:grid-cols-2 mt-6 sm:px-4 lg:px-4 px-4"}>

          <div className="relative rounded-md col-span-2 bg-white px-2 pb-2 pt-3 flex  items-center"> {/*birşeyler ters giderse p-2 yap geç*/}
            <div className="col-span-2 w-full">
              <div className="flex flex-row justify-between  items-start p-0 mb-4  bg-white">
                <p className="mb-4 not-italic  text-lg leading-5  ml-4 font-semibold text-black-50">Hareketler</p>
                {/* <div className="flex flex-row justify-end items-center p-0"> */}
                <div className="flex justify-center">
                  <div className="mb-2 xs:w-36 xl:w-42  ">
                    <CustomDropdown items={chartDropdownList}  >

                      <button className=" border-none text-primary bg-primary-dark-gray  rounded-md p-2 py-1 flex justify-between items-center">
                        <span className="mr-3 text-lg">
                          {chartDropdownList[chartValue - 1].label}
                        </span>

                        <FontAwesomeIcon icon={faCaretDown} />
                      </button>
                    </CustomDropdown>
                  </div>
                </div>
              </div>
              <div className=" flex flex-row ">
                <BarChart chartValue={chartValue}
                  data={orderChartSummaryList?.orderChartSummaryList}
                  labels={orderChartSummaryList?.orderChartSummaryList.dateList}
                />
              </div>
              <div className="flex  ml-2 mt-2">
                <div className="flex  flex-row justify-start  justify-center items-center  ">
                  <p className="w-3 h-3 bg-success-blue rounded-full border-1 border-black flex justify-center items-center mr-2" >
                  </p>
                  <p className="text-xs lg:text-sm  not-italic    text-base leading-0 ">Başarılı</p>
                </div>
                <div className="flex  flex-row justify-start  justify-center items-center xs:ml-2 md:ml-4">
                  <p className="w-3 h-3 bg-error-blue rounded-full border-1 border-black flex justify-center items-center  mr-2">
                  </p>
                  <p className="text-xs lg:text-sm not-italic    text-base leading-0 ">Başarısız</p>
                </div>
                <div className="flex  flex-row justify-start  justify-center items-center xs:ml-2 md:ml-4">
                  <p className="w-3 h-3  bg-warning-purple rounded-full border-1 border-black flex justify-center items-center  mr-2" >
                  </p>
                  <p className="text-xs lg:text-sm  not-italic    text-base leading-0 ">İade</p>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
          <div className={showTotalCollection ? "flex flex-col space-y-1  xs:col-span-2 xl:col-span-1 rounded-md bg-white  w-full" : "hidden"}>
            <div className="ml-5 mt-3">
              <p className="not-italic font-semibold text-lg leading-5 text-black-50">Toplam Tahsilat</p>
            </div>
            <div className="">
              <Box sx={{ width: '100%', typography: 'body1' }}>
                <TabContext value={value} >
                  <Box sx={{

                  }} >
                    <TabList scrollButtons="auto" className="mb-1" onChange={handleChange} >
                      <Tab sx={{ fontSize: '11px', fontWeight: '800', color: '#192434' }} label="Bugün" value="1" />
                      <Tab sx={{ fontSize: '11px', fontWeight: '800', color: '#192434' }} label="Bu Hafta" value="2" />
                      <Tab sx={{ fontSize: '11px', fontWeight: '800', color: '#192434' }} label="Bu Ay" value="3" />
                      <Tab sx={{ fontSize: '11px', fontWeight: '800', color: '#192434' }} label="Bu Yıl" value="4" />
                    </TabList>
                  </Box>
                  <div style={{ overflowY: 'auto' }} >
                    <TabPanel value="1" className="h-64"  >
                      {
                        orderSummaries.isSuccess &&
                        orderSummaries.orderSummaries &&
                        orderSummaries?.orderSummaries[0]?.vpValues?.map((vp, index) => (
                          <div key={index + "orderSummaries.orderSummaries[0].vpValues"} className="flex flex-row justify-items-start justify-between mb-3">
                            <div className="flex items-center justify-center">
                              <img
                                className="grid grid-cols-1 h-10 w-10 rounded-full mr-4 "
                                src={"/" + vp?.bankImagePath?.replace('BankLogo', 'DashboardBankLogo')}
                                alt={vp.vpDisplayName}
                              />
                              <div className="flex flex-row items-center justify-center text-center">
                                <p className="not-italic justify-center text-black-50 text-sm leading-5   font-semibold  " >{vp.vpDisplayName}</p>
                              </div>
                            </div>
                            <div className="flex flex-row items-center justify-center text-center">
                              <p className="not-italic  font-medium text-sm leading-5 text-contrast-50">{formatCurrency(parseFloat(vp.amount))} {orderSummaries.isFetching ? prevCurrencySymbol : currencySymbol}</p>
                            </div>
                          </div>
                        ))}
                    </TabPanel>
                  </div>
                  <div style={{ overflowY: 'auto' }} >
                    <TabPanel value="2" className="h-64">
                      {
                        orderSummaries?.orderSummaries &&
                        orderSummaries?.orderSummaries[1]?.vpValues?.map((vp, index) => (

                          <div key={index + "orderSummaries.orderSummaries[1].vpValues"} className="flex flex-row justify-items-start justify-between mb-3">
                            <div className="flex items-center justify-center">
                              <img
                                className={` grid grid-cols-1 h-10 w-10 rounded-full mr-4`}
                                src={"/" + vp?.bankImagePath?.replace('BankLogo', 'DashboardBankLogo')}
                                alt={vp.vpDisplayName}
                              />
                              <div className="flex flex-row items-center justify-center text-center">
                                <p className="not-italic text-black-50 text-sm leading-5   font-semibold  ">{vp.vpDisplayName}</p>
                              </div>
                            </div>
                            <div className="flex flex-row items-center justify-center text-center">
                              <p className="not-italic  font-bold text-sm leading-5 text-contrast-50">{formatCurrency(parseFloat(vp.amount))} {orderSummaries.isFetching ? prevCurrencySymbol : currencySymbol}</p>
                            </div>
                          </div>
                        ))}
                    </TabPanel>
                  </div>
                  <div style={{ overflowY: 'auto' }} >
                    <TabPanel value="3" className="h-64">
                      {
                        orderSummaries?.orderSummaries &&
                        orderSummaries?.orderSummaries[2]?.vpValues?.map((vp, index) => (
                          <div key={index + "orderSummaries.orderSummaries[2].vpValues"} className="flex flex-row justify-items-start justify-between mb-3">
                            <div className="flex flex-row items-center justify-center">
                              <img
                                className="grid grid-cols-1 h-10 w-10 rounded-full mr-4"
                                src={"/" + vp?.bankImagePath?.replace('BankLogo', 'DashboardBankLogo')}
                                alt={vp.vpDisplayName}
                              />
                              <div className="flex flex-row items-center justify-center text-center">
                                <p className="not-italic text-black-50  text-sm leading-5   font-semibold  " >{vp.vpDisplayName}</p>
                              </div>
                            </div>
                            <div className="flex flex-row items-center justify-center text-center">
                              <p className="not-italic  font-bold text-sm leading-5 text-contrast-50">{formatCurrency(parseFloat(vp.amount))} {orderSummaries.isFetching ? prevCurrencySymbol : currencySymbol}</p>
                            </div>
                          </div>

                        ))}
                    </TabPanel>
                  </div>
                  <div style={{ overflowY: 'auto' }} >
                    <TabPanel value="4" className="h-64">
                      {
                        orderSummaries?.orderSummaries &&
                        orderSummaries?.orderSummaries[3]?.vpValues?.map((vp, index) => (
                          <div key={index + "orderSummaries.orderSummaries[3].vpValues"} className="flex flex-row justify-items-start justify-between mb-3">
                            <div className="flex flex-row items-center justify-center">
                              <img
                                className="grid grid-cols-1 h-10 w-10 rounded-full mr-4 "
                                src={"/" + vp?.bankImagePath.replace('BankLogo', 'DashboardBankLogo')}
                                alt={vp.vpDisplayName}
                              />
                              <div className="flex flex-row items-center justify-center text-center">
                                <p className="not-italic  text-black-50 text-sm leading-5   font-semibold  " >{vp.vpDisplayName}</p>
                              </div>
                            </div>
                            <div className="flex flex-row items-center justify-center text-center">
                              <p className="not-italic  font-bold text-sm leading-5 text-contrast-50">{formatCurrency(parseFloat(vp.amount))} {orderSummaries.isFetching ? prevCurrencySymbol : currencySymbol}</p>
                            </div>
                          </div>

                        ))}
                    </TabPanel>
                  </div>
                </TabContext>
              </Box>
            </div>
          </div>
        </div>
        {/* Projects list (only on smallest breakpoint) */}
        <div className="mt-6 sm:px-4 lg:px-4 px-4 w-full mb-10">
          <div className="max-w-full ">
            <div className="w-full flex flex-col">
              <div className="p-4 bg-white rounded-md overflow-x-auto overflow-y-auto">
                <div className="flex flex-row justify-between">
                  <div className="flex flex-col items-start p-0 flex-none order-none self-stretch flex-grow-0 ">
                    <h2 className="mb-4  ml-2 not-italic   text-lg leading-2 font-semibold text-black-50">
                      Son İşlemler
                    </h2>
                  </div>
                  <div className="flex flex-row  items-start p-0 flex-none order-none self-stretch flex-grow-0 ">
                    <NavLink className="flex flex-row  not-italic  text-sm leading-5 font-semibold font-nunito text-primary "
                      to={getNavigationUrl("/islem-raporu/")}  >
                      <a className="not-italic  text-sm leading-5 font-semibold font-nunito text-primary"
                        target={"_blank"} >
                        Tümünü Görüntüle
                      </a>
                      <a
                        target={"_blank"}
                      >
                        <BsPlayFill
                          className="text-primary text-xs items-center mt-1 ml-2" />
                      </a>
                    </NavLink>
                  </div>
                </div>

                <div className="inline-block w-full py-2 align-middle  ">
                  <div className=" ">
                    <table className="w-full divide-y divide-gray-300 border ">
                      <thead className="bg-gray-50">
                        <tr className="divide-x divide-gray-200">
                          <th
                            scope="col"
                            className="py-3.5 text-center text-left text-sm font-semibold text-contrast-90 sm:pl-2"
                            style={{ width: '60px' }}
                          >
                            Altyapı
                          </th>
                          <th
                            scope="col"
                            className="px-4 py-3.5 text-left text-sm font-semibold text-contrast-90 text-center"
                            style={{ width: '90px' }}
                          >
                            Tarih
                          </th>
                          <th
                            scope="col"
                            className="px-2 py-3.5 text-left text-sm font-semibold text-contrast-90"
                            style={{ width: '120px' }}
                          >
                            Cari Hesap Kodu
                          </th>
                          <th
                            scope="col"
                            className="px-2 py-3.5 text-left text-sm font-semibold text-contrast-90"
                            style={{ width: '150px' }}
                          >
                            Cari Hesap Ünvan
                          </th>
                          <th
                            scope="col"
                            className="px-2 py-3.5 text-left text-sm font-semibold text-contrast-90"
                            style={{ width: '90px' }}
                          >
                            VKN/TCKN
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-4 text-sm font-semibold text-contrast-90 text-right"
                            style={{ width: '90px' }}
                          >
                            Tutar
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-2 text-center text-sm font-semibold text-contrast-90 "
                            style={{ width: '60px' }}
                          >
                            Taksit
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-2 text-sm font-semibold text-contrast-90  text-center"
                            style={{ width: '60px' }}
                          >
                            Durum
                          </th>
                          <th
                            scope="col"
                            className="py-3.5 px-2 text-left text-sm font-semibold text-contrast-90   "
                            style={{ width: '60px' }}
                          ></th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {
                          orderList?.lastOrderList.length > 0 ?
                            orderList.lastOrderList.map((order, index) => (
                              <tr
                                key={index + "orderList.lastOrderList"}
                                className="divide-x divide-gray-200"
                              >
                                <td className="whitespace-nowrap p-2 text-sm font-medium text-gray-900 sm:pl-4">
                                  <div className="flex flex-row justify-center">
                                    <img
                                      src={"/" + order.bankImg.replace('BankLogo', 'DashboardBankLogo')}
                                      className="h-8 w-8 rounded-full"
                                    // src={order.bankImg}
                                    />
                                  </div>
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-gray-500 text-center">
                                  {moment(order.createdate).format("DD.MM.YYYY HH:mm")}
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-gray-500 text-left"  >
                                  {getRowValue(50, order.customercode)}
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-gray-500" title={getRowTooltip(50, order.customername)}>
                                  {getRowValue(50, order.customername)}
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-gray-500">
                                  {getRowValue(11, order.taxcode != null ? order.taxcode : order.tccode)}
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-gray-500">
                                  <span className="flex flex-row justify-end">

                                    {formatCurrency(order.lastamount)} {orderList.isFetching ? prevCurrencySymbol : currencySymbol}
                                  </span>
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm text-gray-500   text-center">
                                  {order.installment === 0 ||
                                    order.installment === 1 || order.installment === null
                                    ? "Peşin"
                                    : order.installment + " Taksit"}
                                </td>
                                <td title={order.transactiontypeid === 1
                                  ? order.orderstatusid === 1
                                    ? "Başarılı"
                                    : order.orderstatusid === 2
                                      ? "Başarısız"
                                      : "Beklemede"
                                  : order.transactiontypeid === 2
                                    ? "İptal"
                                    : "İade"}
                                  className="whitespace-nowrap text-center cursor-default">
                                  <div className="flex flex-row justify-center">
                                    <div
                                      className={order.transactiontypeid === 1
                                        ? order.orderstatusid === 1
                                          ? "w-3 h-3 rounded-full bg-success"
                                          : order.orderstatusid === 2
                                            ? "w-3 h-3 rounded-full bg-error"
                                            : "w-3 h-3 rounded-full bg-primary"
                                        : order.transactiontypeid === 2
                                          ? "w-3 h-3 rounded-full bg-warning"
                                          : "w-3 h-3 rounded-full bg-warning"}
                                    ></div>
                                  </div>
                                </td>
                                <td className="whitespace-nowrap p-2 text-sm  justify-center text-center">
                                  {/* <a href={"/odeme-detayi/" + order.ordercode} className="" >
                                Detaylar
                              </a> */}
                                  <NavLink className="text-primary " to={getNavigationUrl("/odeme-detayi/" + order.ordercode)}  >
                                    Detay
                                  </NavLink>
                                </td>
                              </tr>
                            )) : (
                              <tr>
                                <td colSpan={12} className="divide-x divide-gray-200  text-center font-semibold py-6 sm:py-2 md:py-4">
                                  Herhangi bir kayıt bulunamadı!
                                </td>
                              </tr>
                            )

                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Dashboard;
